<template>
<div class="main-container">
    <div class="inner-container">
        <signed-in-user-info :user="user" :userData="userData" :loadingUser="loadingUser"/>
        <div class="track-shipment update-user">
            <div class="user-info">
                <div class="inner-overflow-container" id="inner-overflow-container">
                    <div class="confirmContainerInner">
                        <div class="confirm-container-address">
                            <div class="confirmContainerInner1">
                                <div class="confirm-svg">
                                    <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264.36 164">
                                        <g id="_Ñëîé_1" data-name="Ñëîé 1">
                                            <g>
                                            <g>
                                                <path class="cls-2" d="M24.36,106v20c0,5.52,4.48,10,10,10h30"/>
                                                <path class="cls-2" d="M112.36,136h50c5.52,0,10-4.48,10-10V14c0-5.52-4.48-10-10-10H65.36"/>
                                                <circle class="cls-2" cx="88.36" cy="136" r="24"/>
                                                <circle class="cls-2" cx="216.36" cy="136" r="24"/>
                                                <line class="cls-2" x1="166.36" y1="136" x2="192.36" y2="136"/>
                                                <path class="cls-2" d="M240.36,136h10c5.52,0,10-4.48,10-10v-38.11c0-2.5-.94-4.91-2.63-6.76l-38.4-41.89c-1.89-2.07-4.57-3.24-7.37-3.24h-39.6"/>
                                                <path class="cls-2" d="M260.36,84h-50c-5.52,0-10-4.48-10-10v-26"/>
                                            </g>
                                            <line class="cls-2" x1="94.78" y1="58" x2="12.72" y2="58"/>
                                            <line class="cls-2" x1="82.06" y1="86" y2="86"/>
                                            <line class="cls-2" x1="105.48" y1="30" x2="23.42" y2="30"/>
                                            </g>
                                        </g>
                                    </svg>
                                    <h2>Payment Details</h2>
                                </div>
                                <div v-if="loadingUser" style="width: 300px; margin-top: 10px;">
                                    <loading-skeleton :loadingHeight="'400px'" />
                                </div>
                                <clover-payment-form v-show="loadingUser == false" @cloverTokenizedCard="cloverTokenizedCard($event)"/>
                            </div>
                        </div>

                        <div class="confirm-container-address">
                            <div class="track-shipment">
                                <div class="confirm-svg">
                                    <h2>Authorize new credit card</h2>
                                </div>
                                <p>
                                    By providing a credit card, I authorize New Jersey Lawyers Serv. dba. LREX to save and automatically charge my credit card when payment is due.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div v-if="loadingData">
    <loading-data/>
</div>
<AlertUser v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
</template>

<script>
import {Auth, API} from 'aws-amplify'
import AlertUser from '../../Popups/AlertUser.vue';
import SignedInUserInfo from '../UserDashboard/SignedInUserInfo.vue';
import CloverPaymentForm from './CloverPaymentForm.vue';
import {cloverCreateCustomer} from '../../../graphql/mutations'
import LoadingData from '../../Popups/LoadingData.vue';
import LoadingSkeleton from '../LoadingSkeleton.vue';

export default {
    data(){
        return{
            user: {},
            jwtToken: null,
            loadingUser: false,
            loadingCard: false,
            loadingData: false,
            userData: {},
            toggleAlertBox: false,
            AdminUser: false,
            InternalAdmin: false,
            Customer: false,
            CustomerAdmin: false,
            ManagePrices: false,
            EditorGroup: false,
            tokenizedCard: null,
            cardData: {}
        }
    },
    components:{
        AlertUser,
        SignedInUserInfo,
        CloverPaymentForm,
        LoadingData,
        LoadingSkeleton
    },
    mounted(){
        Auth.currentAuthenticatedUser().then(user => {
            this.user = user;
            this.jwtToken = user.signInUserSession.accessToken.jwtToken;
            this.GetUserGraphQL();

            if(this.user.signInUserSession.idToken.payload['cognito:groups']){
                this.user.signInUserSession.idToken.payload['cognito:groups'].forEach((group)=>{
                    if(group == 'Admin'){
                      this.AdminUser = true;
                    }

                    if(group == 'InternalAdmin'){
                        this.InternalAdmin = true;
                    }

                    if(group == 'Customer'){
                        this.Customer = true;
                    }

                    if(group == 'CustomerAdmin'){
                        this.CustomerAdmin = true;
                    }

                    if(group == 'ManagePrices'){
                        this.ManagePrices = true;
                    }

                    if(group == 'EditorGroup'){
                        this.EditorGroup = true;
                    }
                })
            }
        }).catch(error => {
          if(error){
            this.$router.push('Login');
            Auth.signOut({global: false})
          }
        });

        this.toggleAlertBox = true;
        this.alertMessage = "You must register a card in order to create shipments."
    },
    methods:{
        async getCustomerInformation(){
            this.loadingCard = true;
            if(this.userData.cloverID){
                this.toggleAlertBox = true;
                this.alertMessage = "User already has cloverID."
                setTimeout(() => {
                    this.$router.push('/CardManagement')
                }, 1500);
                return;
            }
            try {
                let cardReturnData = await API.graphql({
                    query: `mutation MyMutation {
                        cloverGetCustomer(input: {cloverID: "${this.userData.cloverID}"}) {
                            firstName
                            lastName
                            cards {
                                elements {
                                    cardType
                                    expirationDate
                                    first6
                                    last4
                                }
                            }
                        }
                    }`,
                    variables: {
                            cloverID: this.userData.cloverID
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.cardData = cardReturnData.data.cloverGetCustomer;
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to get card information. Authorize a card below."
            }finally{
                this.loadingCard = false;
            }
        },
        async cloverTokenizedCard(event){
            console.log(event)
            this.tokenizedCard = event;
            if(event){
                await this.createCloverCustomer()
            }
        },
        async createCloverCustomer(){
            this.loadingData = true;
            let fullnameParts = this.userData.fullname.split(" ");
            let firstName = fullnameParts[0] || "INVALID FIRSTNAME";
            let lastName = fullnameParts[1] || "INVALID LASTNAME";
            console.log({
                            source: this.tokenizedCard,
                            firstName: firstName,
                            lastName: lastName,
                            email: this.userData.userEmail || ""
                        })
            try {
                let response = await API.graphql({
                    query: cloverCreateCustomer,
                    variables: {
                        input:{
                            source: this.tokenizedCard,
                            firstName: firstName,
                            lastName: lastName,
                            email: this.userData.userEmail || "",
                            username: this.userData.userName
                        }
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })

                if (response && response.data) {
                    console.log('Customer successfully created:', response.data);
                    this.alertMessage = "Customer successfully created!";
                    this.toggleAlertBox = true;
                    this.loadingUser = false;
                    setTimeout(() => {
                        this.$router.push('/CardManagement')
                    }, 1500);
                } else {
                    // Handle the case where no data is returned
                    this.toggleAlertBox = true;
                    this.alertMessage = "Customer creation failed, no data returned.";
                    this.loadingUser = false;
                }
            } catch (error) {
                console.log(error)
                if(error.errors){
                    this.toggleAlertBox = true;
                    this.alertMessage = error.errors[0].message;
                }else{
                    this.toggleAlertBox = true;
                    this.alertMessage = "Unable to create customer."
                }
                
                this.loadingUser = false;
            }finally{
                this.loadingData = false;
            }
        },
        async GetUserGraphQL(){
            this.loadingUser = true;
            try {
                let userReturnData = await API.graphql({
                    query: `query GetUser($userName: String!){
                        getUser(userName: $userName){
                        userName
                        accountNo
                        cloverID
                        fullname
                        locationID
                        userEmail
                        locationAddress{
                        labelImage
                        serviceAddress{
                            address{
                                companyName
                                attention
                                address1
                                address2
                                city
                                state
                                zipCode
                                phone
                                phoneExt
                                relevance
                                latitude
                                longitude
                                }
                        }
                        }
                        labelImage
                    }
                    }`,
                    variables: {
                            userName: this.user.username
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.userData = userReturnData.data.getUser;
                await this.getCustomerInformation();
                if(this.userData.cloverID){
                    this.toggleAlertBox = true;
                    this.alertMessage = "User already has cloverID."
                    setTimeout(() => {
                        this.$router.push('/CardManagement')
                    }, 1500);
                }
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to get user information"
            }finally{
                this.loadingUser = false;
            }
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        }
    }
}
</script>

<style scoped>
.st0{fill:none;stroke:#000000;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;}

.cls-1 {
    fill: none;
    stroke: #3f3f3f;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 10px;
}

.cls-2 {
    fill: none;
    stroke: #000;
    stroke-miterlimit: 10;
    stroke-width: 8px;
}

.cls-2-alt{
    stroke: #000;
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 11px;
}

input, select{
    padding: 10px;
    font-size: 15px;
    border: 1px solid rgba(0,0,0,.336);
    border-radius: 15px;
    outline: none;
    margin-top: 5px;
}


input[type=file]::file-selector-button {
    border: none;
    padding: 5px;
    border-radius: 15px;
    background-color: #32ccfe;
    transition: 1s;
    color: #fff;
    cursor: pointer;
}

input[type=file]::file-selector-button:hover {
    background-color: #2dbbeb;
    transition: 1s;
}

.confirmLabelContainer img{
    width: 50%;
    max-width: 150px;
    margin-top: 5px;
    border-radius: 5px;
}

.confirmLabelContainer{
    display: flex;
    flex-direction: row;
    align-items: center;
}

.file-input{
    width: 80%;
}

html{
    background-color: #f3f3f3;
}

.main-container{
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.inner-container{
    width: 70%;
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    border-radius: 25px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
}

.header-track-shipment{
    width: 100%;
    margin-bottom: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.header-track-inner{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    background-color: #e2e2e2;
    padding: 5px 15px;
    border-radius: 999px;
}

.header-track-inner svg{
    height: 22px;
    margin: 0;
}

.header-track-shipment p{
    font-size: 18px;
    margin: 0;
    margin-left: 10px;
}

.header-track-shipment{
    width: 100%;
    margin-bottom: 5px;
}

input[type="checkbox"] {
    /* Add if not using autoprefixer */
    -webkit-appearance: none;
    /* Remove most all native input styles */
    appearance: none;
    /* For iOS < 15 */
    background-color: #fff;
    /* Not removed via appearance */
    margin: 0;
    margin-top: 5px;
    cursor: pointer;
    padding: 0px !important;

    font: inherit;
    color: #33f18a;
    width: 1.05em;
    height: 1.05em;
    border: 0.15em solid #33f18a;
    border-radius: 0.15em;
    /* transform: translateY(-0.075em); */

    display: grid;
    place-content: center;
    transition-duration: .5s;
}

input[type="checkbox"]:hover{
    background-color: #f3f3f3;
    transition-duration: .5s;
}

input[type="checkbox"]::before {
    content: "";
    width: 0.65em;
    height: 0.65em;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
    transform: scale(0);
    transform-origin: bottom left;
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em var(--form-control-color);
    /* Windows High Contrast Mode */
    background-color: CanvasText;
}

input[type="checkbox"]:checked::before {
    transform: scale(1);
}

.track-shipment{
    background-color: #fff;
    padding: 15px;
    border-radius: 25px;
    flex-basis: 25%;
    width: fit-content;
    height: fit-content;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.card-info{
    width: 90% !important;
}

.update-user{
    flex-basis: 60%;
}

.confirm-svg{
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #e4e4e4;
    border-radius: 999px;
    padding: 5px;
    width: fit-content;
}

.confirm-svg svg{
    width: 35px;
    height: 35px;
    padding-right: 5px;
}

.confirm-svg h2{
    margin: 0;
}

.user-info{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    text-align: left;
}

.user-info p{
    margin: 0;
}

.confirmContainerInner{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    text-align: left;
    padding: 10px;
}

.auto-complete-container{
    margin-top: 5px !important;
    width: 90%;
    margin-left: 10px;
}

.update-user-button{
    background-color: #e4e4e4;
    color: #000;
    border: none;
    border-radius: 999px;
    padding: 5px 15px;
    width: fit-content;
    margin-top: 5px;
    margin-left: 10px;
    margin-bottom: 5px;
    transition-duration: .5s;
    cursor: pointer;
}

.update-user-button:hover{
    transition-duration: .5s;
    background-color: #d5d5d5;
}

@media only screen and (max-width: 1300px) {
    .inner-container{
        width: 85%;
    }
}

@media only screen and (max-width: 1000px) {
    .data-container-main, .inner-track-shipment-container{
        flex-wrap: wrap;
    }

    .track-shipment{
        flex-basis: 70%;
    }

    .data-container{
        flex-basis: 40%;
    }
}

@media only screen and (max-width: 600px) {
    .inner-container{
        width: 95%;
    }

    .data-container{
        flex-basis: 80%;
    }

    .track-shipment{
        flex-basis: 80%;
    }

    .confirmContainerInner{
        flex-wrap: wrap;
    }

    .notifications{
        margin-top: 5px;
    }
}
</style>